import { Avatar, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React from 'react'
import useTranslation from '../../../i18n/useTranslation'

const HeadFilter = (props) => {
  const { headFilters, setHeadFilters, heads = [] } = props
  const { translate } = useTranslation()

  const checkboxSelectorProps = {
    setDataFilters: setHeadFilters,
    direction: 'bottomCenter',
    dataFilters: headFilters,
    typeFilter: 'statuses',
    data: heads?.map((head) => ({
      name: `${head.firstName} ${head.lastName}`,
      id: head.id,
      Component: (
        <Avatar
          name={`${head.firstName} ${head.lastName}`}
          named={false}
          uri={null}
          size='avatar-small'
        />
      )
    })),
    strings: {
      title:"Head Counselor",
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/>
  )
}

export default HeadFilter
